import type {
  ApiZapierIntegration,
  ZapierIntegration,
} from "@app/analytics/types/zapierTypes";
import { get, httpDelete, post } from "@app/common/api";
import { generateRandomString } from "@app/common/utils/randomUtils";

import { parseZapierApiKeys } from "../parsers/integrations";

export const listApiKeys = async (): Promise<ZapierIntegration[]> => {
  const res: ApiZapierIntegration[] = await get(
    "/integrations/zapier/api-keys",
    { withCreds: true }
  );
  return parseZapierApiKeys(res);
};

export const createApiKey = async () => {
  return post(
    "/integrations/zapier/api-keys",
    { name: generateRandomString(10) },
    { withCreds: true }
  );
};

export const deleteApiKey = async ({ id }: { id: ZapierIntegration["id"] }) => {
  return httpDelete(`/integrations/zapier/api-keys/${id}`, {
    withCreds: true,
  });
};

export const regenerateApiKey = async ({
  id,
}: {
  id: ZapierIntegration["id"];
}) => {
  await deleteApiKey({ id });
  return createApiKey();
};

export const sendTestRequest = async () => {
  return post("/integrations/zapier/webhooks/test", {}, { withCreds: true });
};
